import Cookie from 'cookie-universal'

import { ONE_DAY } from '@mc/constants'

import { AUTH_STARTED_COOKIE_KEY } from '../constants'

export const setAuthStartedCookie = () => {
  const cookies = Cookie()

  cookies.set(AUTH_STARTED_COOKIE_KEY, true, { maxAge: ONE_DAY })
}
